import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { resetPassword } from "./actions";
import ResetPassword from "./component";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      resetPasswordConnect: resetPassword,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
